module.exports = __webpack_public_path__ + "static/img/clientChallengeBg2.3dd4fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/clientChallengeBg2.jpg
// module id = 8zs0
// module chunks = 0